// extracted by mini-css-extract-plugin
export default {"dropdownContainer__itemsContainer":"styles_dropdownContainer__itemsContainer__jvNJ6","dropdownContainer__items":"styles_dropdownContainer__items__GnXCX"};